import axios, { AxiosRequestConfig } from "axios";
import { IApiError } from "@/interfaces/IApiError";
import { ref } from "vue";

export const useApi = (url: string) => {
  const api = axios.create({
    baseURL:  process.env.ApiServicesUrl,
  });

  const loading = ref(false);

  const get = <T>(id?: string, query?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
    
    loading.value = true;
    
    let completeUrl = url;
    if(id)
    {
      completeUrl += '/' + id;
    }

    let queryString = '';
    if (query) {
      queryString = '?' + new URLSearchParams(query).toString();
    }

    return api.get(completeUrl + queryString, config)
      .then(response => response.data as T)
      .catch(handleError)
      .finally(() => loading.value = false);
  }

  const handleError = (error: any): Promise<never> => {
    const responseData = error?.response?.data;
    const message = typeof responseData === "string"
      ? responseData
      : responseData?.message || error?.message || "Unknown error";

    return Promise.reject({
      message,
      status: error?.response?.status,
      code: error?.code,
      details: responseData
    } as IApiError);
  }

  return {
    get,
    loading
  }
}
